import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'
import { firebaseMessaging } from '../../helper/fcm'

/**
 * fetch fcm token for notification
 */
const fetchFcmToken = async function () {
  console.log('TCL: fetchFcmToken called')
  try {
    let currentToken = await firebaseMessaging().getToken()
    console.log('TCL: currentToken', currentToken)
    return currentToken
  } catch (error) {
    alert('An error occurred while retrieving token. ' + error)
    return Promise.reject(error)
  }
}

/**
 * fetch user's notification list
 * @param {Number} page notification page number
 */
const fetchNotificationList = async function (page) {
  console.log('TCL: fetchNotificationList -> page', page)
  try {
    let filters = {
      page: page - 1,
      size: 10,
    }
    const res = await axios.get(urls.notificationList + '?' + querystring.stringify(filters))
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    console.log('TCL: }catch -> error', error)
    return Promise.reject(error)
  }
}

const fetchNotificationUnreadCount = async function () {
  try {
    let res = await axios.get(urls.notificationUnreadCount)
    return res.data
  } catch (error) {
    console.log('TCL: }catch -> error', error)
    return Promise.reject(error)
  }
}

const setNotificationRead = async function () {
  try {
    let res = await axios.put(urls.notification, {
      'notifId': 0
    })
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchNotificationList,
  fetchFcmToken,
  fetchNotificationUnreadCount,
  setNotificationRead,
}
